export const formatDateFromSlashToDot = (str: string) => str.replace(/\//g, '.');
